import React from 'react';

import BuyersJackpot from './BuyersJackpot';
import Jackpot from './Jackpot';

// The stage: the number jackpot for the participants, or the clients' jackpot when that was
// the last thing launched. Whatever the admin launches takes over the screen everywhere
const Games = ({ draws, participant, hidden, showTotal }) => (
  <div className='stage' hidden={hidden}>
    {draws.latest === 'buyers' ? (
      <BuyersJackpot draw={draws.buyers} participant={participant} showTotal={showTotal} />
    ) : (
      <Jackpot jackpot={draws.jackpot} />
    )}
  </div>
);

export default Games;
